import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Typography, Button, Box, Paper, Chip,
  TextField,

} from "@mui/material";

import ReactTimeAgo from 'react-time-ago';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip
} from "@mui/material";
import { useCookies } from "react-cookie";
import BackspaceIcon from '@mui/icons-material/Backspace';
import PrintReceipt from "./PrintReceipt";

const KASSE_ENDPOINT = 'https://fkcrenezvf.execute-api.eu-central-1.amazonaws.com/Prod';

export default function Transactions({ crsClientId, prepareReversal }) {

  const [cookies] = useCookies(['crKey'])
  const [transactions, setTransactions] = useState([]);

  const authHeaders = {
    headers: {
      Authorization: `Bearer ${cookies.crKey} y 1 z`,
    },
  };

  useEffect(() => {
    loadTransactions();
  }, [])

  const loadTransactions = async () => {
    const { data } = await axios.get(KASSE_ENDPOINT + `/transactions?client_id=${crsClientId}&bon_id=${search}`, authHeaders);
    setTransactions(data.items);
  };

  const [search, setSearch] = useState();

  const searchHandler = () => {
    loadTransactions();
  };

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Letzte Transaktionen</Typography>
      <TextField size="small" value={search} onChange={(evt) => setSearch(evt.target.value)} /> <Button onClick={searchHandler}>Suchen</Button>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Betrag</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Zuletzt</TableCell>
              <TableCell align="right">Aktion</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.map((tx) => {
              const isFullyRefunded = tx.CancellationStatus === "full";
              const isPartiallyRefunded = tx.CancellationStatus === "partial";
              const isRefund = !!tx.ReversalOf;
              const original = transactions.find(t => t.TransactionId === tx.ReversalOf);
              const amount = (tx.Items || []).reduce((sum, p) => sum + p.item.quantity * p.item.price_per_unit * (p.storno ? -1 : 1), 0).toFixed(2);
              const isTrainingTx = tx.TrainingMode === true;



              return (
                <TableRow key={tx.TransactionId}>
                  <TableCell sx={{ fontSize: '0.75rem' }}>
                    <Tooltip title={tx.TransactionId}>
                      <span>
                        <span>{tx.TransactionId.slice(0, 8)}…</span>
                        {isTrainingTx && (
                          <Chip size="small" label="🎓 Training" />
                        )}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(amount)}
                  </TableCell>
                  <TableCell>
                    {isRefund ? (
                      <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>↩️ Storno</span>
                    ) : isFullyRefunded ? (
                      <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>❌ Vollständig storniert</span>
                    ) : isPartiallyRefunded ? (
                      <span style={{ color: '#ed6c02', fontWeight: 'bold' }}>⚠️ Teilweise storniert</span>
                    ) : tx.Type === "AVBelegabbruch" ? (
                      <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>❌ Belegabbruch</span>
                    ) : (
                      <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>✅ Abgeschlossen</span>
                    )}
                  </TableCell>
                  <TableCell>
                    <Tooltip title={new Date((tx.UpdatedAt || 0) * 1000).toLocaleString("de-DE", { timeZone: "Europe/Berlin" })}>
                      <span>
                        <ReactTimeAgo date={(tx.UpdatedAt || 0) * 1000} locale="de" />
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <Box display={"flex"} gap={2} justifyContent={"flex-end"}>


                      {tx?.eReceipt?.assets?.pdf_link && <PrintReceipt pdfUrl={tx?.eReceipt?.assets?.pdf_link} />}
                      {!!prepareReversal && !isRefund && !isFullyRefunded && (tx.Type === 'Beleg' || tx.Type === 'AVTraining') && (
                        <Button
                          variant="outlined"
                          color="error"
                          size="small"
                          onClick={() => prepareReversal(tx)}
                          startIcon={<BackspaceIcon />}
                        >
                          Erstattung
                        </Button>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>

  );
}
